import { useState, useEffect } from 'react'
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Modal } from 'react-bootstrap';
import { baseUrl } from '../../utils/apiActions/dashboardApi';
import { toastError, toastSuccess } from '../../utils/toastrResponse';
import Locations from '../Locations';
import SweetAlert from "react-bootstrap-sweetalert";
import DOMPurify from "dompurify";

const UpdateUser = ({ show, hide, user }) => {
  const [selectedGroup, setSelectedGroup] = useState();
  const [userGroups, setUserGroups] = useState([]);
  const [updateData, setUpdateData] = useState(user);
  const [userStatuses, setUserStatuses] = useState([]);
  const [locationId, setLocationId] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [checked, setChecked] = useState({
    changeUserDetails: true,
    changeLocation: false,
    changeGroup: false,
  });
  const userToken = JSON.parse(localStorage.getItem("user"));
  const queryClient = useQueryClient();
  // handle change on update
  const handleOnchange = (e, key) => {
    setUpdateData({
      ...updateData,
      [key]: DOMPurify.sanitize(e.target.value),
    });
  };

  const updateUser = () => {
    const url = `${baseUrl}/users`;
    fetch(url, {
      method: "PUT",
      headers: new Headers({
        Authorization: "Bearer " + userToken.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(updateData),
    })
      .then((res) => {
        if (res.ok) {
          hide();
          queryClient.invalidateQueries(["fetch-users"]);
          toastSuccess("User updated successfully");
        } else {
          toastError("Could not update user");
        }
        return res.json();
      })
      .then((res) => {
        queryClient.invalidateQueries(["fetch-users"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Fetch groups
  const fetchUserGroup = () => {
    const url = `${baseUrl}/users/groups`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + userToken.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setUserGroups(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchUserStatus = () => {
    const url = `${baseUrl}/users/statuses`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + userToken.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setUserStatuses(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    setUpdateData(user);
    fetchUserGroup();
    fetchUserStatus();
  }, [user]);
  const handleDataFromLocationsComponent = (data) => {
    setLocationId(data?.locationId);
  };
  // Assign user to a locations
  const assingUserToLocation = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        locationId,
        userId:user?.id,
      };
      const url = `${baseUrl}/users/${user?.id}/locations`;
      const assignLocation = await fetch(url, {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + userToken.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(dataToSend),
      });
      if (assignLocation.ok) {
        toastSuccess("Location Assigned to a user");
        hide();
        queryClient.invalidateQueries(["fetch-users"])
      } else {
        toastError("Could not assign location to a user");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // Assign group to a locations
  const assingUserToGroup = async (e) => {
    e.preventDefault();
    try {
      const url = `${baseUrl}/users/${user?.id}/groups`;
      const assignGroup = await fetch(url, {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + userToken.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          userId: user?.id,
          groupId: selectedGroup,
        }),
      });
      if (assignGroup.ok) {
        toastSuccess("Group Assigned to a user");
        hide();
        queryClient.invalidateQueries(["fetch-users"])
      } else {
        toastError("Could not assign group to a user");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // Reset user passwrod
  const resetPassword = () => {
    const username = updateData?.username;
    const url = `${baseUrl}/users/${username}/resetpassword`;
    fetch(url, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + userToken.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => {
        if (res.ok) {
          toastSuccess("Password reset successfully");
          setShowAlert(false);
        } else {
          toastError("Could not reset user password");
        }
        return res.json();
      })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>Update User</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <div className='d-flex justify-content-center mb-4'>
            <Form.Check
              type='radio'
              id='user details'
              label='Details'
              name='update'
              checked={checked.changeUserDetails}
              onChange={() =>
                setChecked({
                  changeUserDetails: true,
                })
              }
            />
            <div>
              <Form.Check
                type='radio'
                label='Location'
                id='location'
                className='ml-2'
                name='update'
                checked={checked.changeLocation}
                onChange={() =>
                  setChecked({
                    changeLocation: true,
                  })
                }
              />
            </div>
            <div>
              <Form.Check
                type='radio'
                label='Group'
                id='group'
                className='ml-2'
                name='update'
                checked={checked.changeGroup}
                onChange={() =>
                  setChecked({
                    changeGroup: true,
                  })
                }
              />
            </div>
          </div>
          {checked.changeUserDetails ? (
            <>
              <input
                className='form-control input-select mb-2'
                value={updateData?.id}
                disabled
              />
              <input
                placeholder='First Name'
                className='form-control input-select mb-2'
                name='firstName'
                value={updateData?.firstName}
                onChange={(e) => handleOnchange(e, "firstName")}
              />
              <input
                placeholder='Last Name'
                className='form-control input-select mb-2'
                value={updateData?.lastName}
                name='lastName'
                onChange={(e) => handleOnchange(e, "lastName")}
              />
              <input
                placeholder='Username'
                className='form-control input-select mb-2'
                value={updateData?.username}
                name='username'
                onChange={(e) => handleOnchange(e, "username")}
              />
              <input
                placeholder='Phone number'
                className='form-control input-select mb-2'
                value={updateData?.phoneNumber}
                name='pnoneNumber'
                onChange={(e) => handleOnchange(e, "phoneNumber")}
              />
              <input
                placeholder='Email Address'
                className='form-control input-select mb-2'
                value={updateData?.emailAddress}
                name='emailAddress'
                onChange={(e) => handleOnchange(e, "emailAddress")}
              />
              <select
                className='form-control input-select mb-2'
                name='status'
                onChange={(event) => {
                  const statusName =
                    event.target.options[event.target.selectedIndex].text;
                  setUpdateData({
                    ...updateData,
                    status: {
                      id: event.target.value,
                      name: statusName,
                    },
                  });
                }}
              >
                {hide ? <option>{updateData?.status?.name}</option> : <></>}
                {userStatuses?.map((status, index) => {
                  if (status?.name === updateData?.status?.name) return null;
                  return (
                    <option value={status.id} key={index}>
                      {status.name}
                    </option>
                  );
                })}
              </select>
              <div className='d-flex justify-content-end'>
                <p
                  style={{ color: "#124db1",fontWeight:700, cursor: "pointer" }}
                  onClick={() => setShowAlert(true)}
                >
                  Reset Password
                </p>
              </div>
              {/* <div className='d-flex' style={{ gap: 10 }}>
                {updateData?.groups?.map((group, index) => (
                  <div
                    className='d-flex mt-2 pl-1 pb-1 pr-1'
                    key={group.id}
                    style={{
                      border: "1px #eee solid",
                      backgroundColor: "#e9ecef",
                      maxWidth: 150,
                      borderRadius: 5,
                    }}
                  >
                    {group.name}
                    <div
                      className='d-flex justify-content-center mt-1 ml-2'
                      style={{
                        width: 13,
                        height: 13,
                        borderRadius: "50%",
                        backgroundColor: "#8f250d",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const updatedUserGroup = [...user.groups];
                        updatedUserGroup.splice(index, 1);
                        setUpdateData({
                          ...updateData,
                          groups: updatedUserGroup,
                        });
                      }}
                    >
                      <span
                        style={{
                          fontSize: 10,
                          color: "#FFF",
                          marginBottom: 2,
                        }}
                      >
                        x
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div className='d-flex' style={{ gap: 20 }}>
                <select
                  value={selectedGroup}
                  className='form-control input-select mt-1'
                  onChange={(event) => {
                    const text =
                      event.target.options[event.target.selectedIndex].text;
                    const value = event.target.value;
                    setSelectedGroup(value);
                    const selected = {
                      id: value,
                      name: text,
                    };
                    const checkIfGroupExist = user.groups.filter(
                      (group) => group.name === text
                    );
                    if (checkIfGroupExist.length === 0 && text !== "group")
                      user?.groups?.push(selected);
                  }}
                >
                  <option>group</option>
                  {userGroups?.map((group, index) => (
                    <option value={group.id} key={index}>
                      {group.name}
                    </option>
                  ))}
                </select>
              </div> */}
            </>
          ) : checked.changeLocation ? (
            <Locations
              sendDataToParent={handleDataFromLocationsComponent}
              flexDirection='column'
            />
          ) : (
            <>
              <div className='d-flex' style={{ gap: 10 }}>
                {updateData?.groups?.map((group, index) => (
                  <div
                    className='d-flex mt-2 pl-1 pb-1 pr-1'
                    key={group.id}
                    style={{
                      border: "1px #eee solid",
                      backgroundColor: "#FFF",
                      maxWidth: 150,
                      borderRadius: 5,
                    }}
                  >
                    {group.name}
                  </div>
                ))}
              </div>
              <div className='d-flex' style={{ gap: 20 }}>
                <select
                  value={selectedGroup}
                  className='form-control input-select mt-1'
                  onChange={(event) => {
                    const text =
                      event.target.options[event.target.selectedIndex].text;
                    const value = event.target.value;
                    setSelectedGroup(value);
                  }}
                >
                  <option>group</option>
                  {userGroups?.map((group, index) => (
                    <option value={group.id} key={index}>
                      {group.name}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}

          <div className='d-flex justify-content-center mt-2'>
            <Button
              className='custom-btn-color'
              onClick={
                checked.changeUserDetails
                  ? updateUser
                  : checked.changeLocation
                  ? assingUserToLocation
                  : assingUserToGroup
              }
            >
              Update
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <SweetAlert
        title={`This will reset ${updateData.firstName} ${updateData.lastName}'s password. Proceed?`}
        onConfirm={resetPassword}
        onCancel={() => setShowAlert(false)}
        show={showAlert}
        showConfirm={true}
        showCancel={true}
        type='warning'
        cancelBtnBsStyle='primary'
        confirmBtnBsStyle='success'
        cancelBtnText='No'
        confirmBtnText='Yes'
      />
    </div>
  );
}

export default UpdateUser